import { paymentMethodRemoveApi } from 'constants/AppConstants';
import { logError } from 'utils/logger.utils';

// #genai Phase 2 — PUT remove a saved payment method. Empty request body; success 200 returns
// { type, id, removed: true }. Removing the current default while siblings exist rejects with
// 409 CannotRemoveDefault — the caller must set another default first.
const removePaymentMethod = async ({ type, id }) => {
  try {
    const response = await fetch(paymentMethodRemoveApi(type, id), {
      headers: { 'Content-Type': 'application/json' },
      method: 'PUT',
    });
    const json = await response.json().catch(() => null);
    // #genai Accept any 2xx (response.ok), not only 200 — mirrors setPaymentMethodDefault so a
    // non-200 success (e.g. 204) is not misread as a failure and does not roll back the optimistic
    // remove. The saga still checks status === 409 (CannotRemoveDefault) before this branch.
    if (!response.ok) return { ok: false, status: response.status, json };
    return { ok: true, status: response.status, json };
  } catch (error) {
    logError('removePaymentMethod failed', error);
    return { ok: false, status: 0, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default removePaymentMethod;
